(function($) {
	// Change text of backbutton in mobile-drilldown menu
	$('.js-drilldown-back > a').each(function(){
		var backTxt = $(this).parent().closest('.is-drilldown-submenu-parent').find('> a').text();
		$(this).text(backTxt);
	});

	$('[data-drilldown]').on('open.zf.drilldown', function() {
		$('.is-drilldown').css('min-height', $('.drilldown ul.is-active').height());
		$('.is-drilldown').css('height', $('.drilldown ul.is-active').height());
	});

	$('.is-drilldown-submenu-parent .js-drilldown-back a').on('click', function() {
		// Reset height of drilldown
		$('.is-drilldown').css('min-height', $('.drilldown').height());
		$('.is-drilldown').css('height', $('.drilldown').height());
	});

	$('[data-toggle]').on('click.isactive', function () {
		$('.is-drilldown').css('min-height', $('.drilldown').height());
	});
	$('.mega-menu-link, .ct-component-meganavigation .menu-item a').each(function(item) {
		$(this).attr('title', $(this).text());
	  });
})(jQuery); 
